module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./LinearGauge.js"));
	}, "LinearGauge");
}